module.exports = __webpack_public_path__ + "media/images/front/icons/info-purple-f865fbca40a047e2e70aa935d325fc8b.svg";